import React from 'react'
import Select from 'meinian-package/src/baseComponent/select'
import { GENDER_VALUE } from 'meinian-package/src/component/enum'

export default (props) => {
  return <Select
    placement="bottomRight"
    placeholder="行业"
    {...props}
    data={props.data || [{ label: '女装', value: GENDER_VALUE.WOMEN },
      { label: '男装', value: GENDER_VALUE.MEN },
      { label: '男童', value: GENDER_VALUE.BOY },
      { label: '女童', value: GENDER_VALUE.GIRL },
      { label: '童装', value: GENDER_VALUE.CHILD },
      { label: '鞋靴', value: GENDER_VALUE.SHOES }]}
  />
}
